import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';

const colorPalette = [
  '#000000', '#ffffff', '#E53935', '#D81B60', '#E91E63', '#8E24AA', '#9C27B0', '#AB47BC', '#5E35B1', '#3949AB',
  '#5C6BC0', '#1E88E5', '#2196F3', '#42A5F5', '#039BE5', '#00ACC1', '#26C6DA', '#26A69A', '#4DB6AC', '#43A047',
  '#4CAF50', '#66BB6A', '#7CB342', '#9CCC65', '#C0CA33', '#D4E157', '#FDD835', '#FFEB3B', '#FFC107', '#FFB300',
  '#FF9800', '#FB8C00', '#F4511E', '#8D6E63', '#795548', '#6D4C41', '#757575', '#9E9E9E', '#BDBDBD', '#546E7A',
  '#607D8B'
];
@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit {
  @Input() innerValue: string;
  @Output() innerValueChange = new EventEmitter<string>();
  @Input() hideToolbar: boolean = false;


  wordCount: number = 0;
  showTextColorOptions: boolean = false;
  showBgColorOptions: boolean = false;
  selectedTextColor: string = '#000000';
  selectedBgColor: string = '#ffffff';
  colorPalette: string[] = colorPalette;
  formatBlock: string = 'P'
  floatingToolbar: boolean = true;

  constructor(private renderer: Renderer2,) { }

  ngOnInit(): void {
    const textArea = document.getElementById('text-area') as HTMLElement;
    if (this.innerValue === undefined) this.innerValue = ''
    textArea.innerHTML = this.innerValue
    // Initialize any logic needed on component initialization
  }
  executeCommand(command: string, value?: any) {
    if (command === 'createLink' && value) {
      const selectedText = window.getSelection()?.toString();
      if (selectedText) {
        const link = prompt('Enter the URL for the link:', 'http://');
        if (link) {
          const anchor = document.createElement('a');
          anchor.href = link;
          anchor.textContent = selectedText;
          anchor.target = '_blank'; // Optional: open link in a new tab
          const range = window.getSelection()?.getRangeAt(0);
          range.deleteContents();
          range.insertNode(anchor);
        }
      }
    } else {
      document.execCommand(command, false, value);
    }
    this.focusTextArea();
    if (command === 'foreColor') {
      this.selectedTextColor = value; // Update selected text color
    }
    if (command === 'backColor') {
      this.selectedBgColor = value; // Update selected bg color
    }
  }

  updateWordCount(event: any) {
    const text = event.target.innerText.trim();
    const words = text.split(/\s+/).filter(word => word.length > 0);
    this.wordCount = words.length;
    this.autoResizeTextArea(event)
    this.innerValueChange.emit(event.target.innerHTML);
  }
  exportContent() {
    const textArea = document.getElementById('text-area') as HTMLElement;
    const content = textArea.innerHTML;
    const blob = new Blob([content], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'content.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }

  toggleColorPicker(type: string) {
    if (type === 'text-color') {
      this.showTextColorOptions = !this.showTextColorOptions;
    } else if (type === 'bg-color') {
      this.showBgColorOptions = !this.showBgColorOptions;
    }
  }


  handleImageUpload(event: Event) {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const imgSrc = e.target.result;
        this.insertImage(imgSrc);
        this.addSpaceToTextArea(); // Trigger text-area to add space
      };
      reader.readAsDataURL(file);
    }
  }

  addSpaceToTextArea() {
    const textArea = document.getElementById('text-area') as HTMLElement;
    textArea.innerHTML += '&nbsp;'; // Add a non-breaking space
    const event = new Event('keyup');
    textArea.dispatchEvent(event); // Trigger keyup event
    this.innerValueChange.emit(textArea.innerHTML);
  }

  insertImage(imgSrc: string) {
    const image = new Image();
    image.src = imgSrc;
    image.style.maxWidth = '50%';
    image.style.cursor = 'move'; // Add cursor style for dragging
    const textArea = document.getElementById('text-area') as HTMLElement;

    // Get the active cursor (caret) position in the text-area element
    let selection = window.getSelection();
    let range = null;
    if (selection && selection.rangeCount > 0) {
      range = selection.getRangeAt(0);
      // Ensure the selection is within the text-area
      if (!textArea.contains(range.commonAncestorContainer)) {
        range = null;
      }
    }

    if (range) {
      // Insert the image at the current cursor position
      range.collapse(false); // collapse to end of selection
      range.insertNode(image);

      // Move the cursor after the inserted image
      range.setStartAfter(image);
      range.setEndAfter(image);
      selection?.removeAllRanges();
      selection?.addRange(range);
    } else {
      // If no valid range, append at the end
      textArea.appendChild(image);
    }
  }

  triggerImageUpload() {
    const imageUpload = document.getElementById('image-upload') as HTMLInputElement;
    imageUpload.click();
  }

  updateFontSizeDropdown() {
    const selection = document.getSelection();
    const parentElement = selection?.anchorNode?.parentNode as HTMLElement;
    const fontSize = parentElement?.style?.fontSize;
    const fontSizeDropdown = document.getElementById('font-size') as HTMLSelectElement;
    if (fontSize) {
      fontSizeDropdown.value = fontSize;
    }
  }

  autoResizeTextArea(event: Event) {
    const textArea = event.target as HTMLElement;
    textArea.style.height = 'auto';
    textArea.style.height = textArea.scrollHeight + 'px';
  }

  focusTextArea() {
    const textArea = document.getElementById('text-area') as HTMLElement;
    textArea.focus();
  }

  addHyperlink() {
    const url = prompt('Enter the URL for the link:', 'http://');
    let text = prompt('Enter URL placeholder', 'Click Here');
    if (url && text) {
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.textContent = text;
      anchor.classList.add('text-primary');
      anchor.style.textDecoration = 'underline';
      anchor.target = '_blank';
      const textArea = document.getElementById('text-area') as HTMLElement;
      textArea.appendChild(anchor);
      this.innerValueChange.emit(textArea.innerHTML);
    }
  }

  getCurrentElementFocus() {
    const selection = document.getSelection();
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      let focusedElement = range.startContainer.parentElement;
      if (focusedElement && focusedElement.tagName === 'STRONG') {
        focusedElement = focusedElement.parentElement;
      }
      if (focusedElement && /^H[1-6]$/.test(focusedElement.tagName)) {
        this.formatBlock = focusedElement.tagName.toUpperCase();
        return focusedElement;
      }
    }
    this.formatBlock = 'P';
    return null;
  }
}
